import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosResponse } from 'axios'
import { EpaApi } from '../../../services'
import { ParameterDetail, ParameterDetailsState } from '../types'

export const fetchParameterDetailsAsync = createAsyncThunk(
  'parameterDetails/fetchDetails',
  async (parameterName: string, { rejectWithValue }) => {
    try {
      const encodedName = encodeURIComponent(parameterName);
      const response = await EpaApi.getParameterDetails(encodedName, {params:{'$includes':"epa_regulation"}});
      return (response as AxiosResponse<ParameterDetail>).data;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data?.message || 'Failed to fetch parameter details');
    }
  }
);

export const fetchParameterDetailsAsyncBuilder = (
  builder: ActionReducerMapBuilder<ParameterDetailsState>
) => {
  builder
    .addCase(fetchParameterDetailsAsync.pending, (state) => {
      state.loading = true;
      state.status = 'loading';
      state.error = null;
    })
    .addCase(fetchParameterDetailsAsync.fulfilled, (state, action) => {
      state.loading = false;
      state.status = 'succeeded';
      state.data = action.payload;
    })
    .addCase(fetchParameterDetailsAsync.rejected, (state, action) => {
      state.loading = false;
      state.status = 'failed';
      state.error = action.payload as string;
    });
};